export default "<p>video-player works!</p>\r\n"